import React, { useContext, useRef, useState } from 'react';
import { MenuList } from '@/components/menuList';
import { useNavigate } from 'react-router-dom';
import { Button, IconButton, Menu, MenuButton, MenuItem, Skeleton, Spinner, list } from '@chakra-ui/react';
import { Box, Text} from '@chakra-ui/layout';
import { MdAdd, MdArrowBack, MdOutlineLayers } from 'react-icons/md';
import SharedExperienceIcon from '../../../components/icons/sharedExperienceIcon';
import { useDisclosure } from '@chakra-ui/react-use-disclosure';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/modal';
import { Icon } from '@chakra-ui/icon';
import { MdOutlineRoute } from 'react-icons/md';
import { ProductContext } from '../../lib/productContext';
import AddExperienceToProductForm from './AddExperienceToProductForm';
import NewExperienceInProductForm from './newExperienceInProductForm';
import NewExperienceGroupInProductForm from './newExperienceGroupInProductForm';
import AddSharedExperienceToProductModalForm from './AddSharedExperienceToProductModalForm';
import SharedExperienceForm from '@/shared-experiences/components/sharedExperienceForm';
import { useSharedExperiencesApi } from '@/shared-experiences/lib/useSharedExperiencesApi';
import useTranslation from '../../../lib/i18n/useTranslation';
export default function ExperiencesInProductListMenu(props) {
  const { t } = useTranslation();
  const {
    productId,
  } = useContext(ProductContext);
  const {
    hasExperiences = false,
    onNew,
    group,
    variant = 'purpleOutline'
  } = props;
  const sharedExperiencesApi = useSharedExperiencesApi();
  const navigate = useNavigate();
  const [isAdding, setIsAdding] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [objectiveDefault, setObjectiveDefault] = useState(null);
  const modalCreateExperience = useDisclosure();
  const modalAddExperience = useDisclosure();
  const modalAddExperienceGroup = useDisclosure();
  const modalAddSharedExperience = useDisclosure();
  const modalCreateSharedExperience = useDisclosure();
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  return (
    <>
      <Menu>
        {({ isOpen }) => (
          <>
            <MenuButton
              isActive={isOpen}
              as={IconButton}
              icon={<MdAdd />}
              variant={variant}
              style={{
                'opacity': !hasExperiences ? '0' : '1',
                'pointerEvents': !hasExperiences ? 'none' : 'inherit'
              }}
            />
            <MenuList>
              <MenuItem onClick={modalAddExperience.onOpen}>
                <Icon
                  as={MdOutlineRoute}
                  boxSize={'15px'}
                  mr={2}
                />
                <Text>Add Experience</Text>
              </MenuItem>
              <MenuItem onClick={modalAddExperienceGroup.onOpen} >
                <Icon
                  as={MdOutlineLayers}
                  boxSize={'15px'}
                  mr={2}
                />
                <Text>New Experience Group</Text>
              </MenuItem>
              <MenuItem onClick={modalAddSharedExperience.onOpen} >
                <Icon
                  as={SharedExperienceIcon}
                  boxSize={'15px'}
                  mr={2}
                />
                <Text>{t('product.addSharedExperiences')}</Text>
              </MenuItem>
            </MenuList>
          </>
        )}
      </Menu>
      <Modal isOpen={modalAddExperience.isOpen} onClose={modalAddExperience.onClose}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>Add Experience</ModalHeader>
          <ModalBody >
            <Box p={3}>
              <AddExperienceToProductForm
                productId={productId}
                groupId={group ? group.id : null}
                onCreateNew={(e) => {
                  setObjectiveDefault(e);
                  modalAddExperience.onClose();
                  modalCreateExperience.onOpen();
                }}
                hideSave={true}
                onSubmitting={() => {
                  setIsAdding(true);
                }}
                onSubmitted={async () => {
                  setIsAdding(false);
                  await onNew();
                  modalAddExperience.onClose();
                }}
                ref={ref1}
              />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="purpleOutline"
              onClick={modalAddExperience.onClose}
            >Cancel</Button>
            <Button
              variant="purpleFill"
              ml={2}
              isLoading={isAdding}
              onClick={() => {
                ref1.current.click();
              }}>Save</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={modalCreateExperience.isOpen} onClose={modalCreateExperience.onClose}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>
            <IconButton
              fontSize='24'
              variant="tertiary"
              icon={<MdArrowBack />}
              aria-label='New'
              mr={2}
              onClick={() => {
                modalCreateExperience.onClose();
                modalAddExperience.onOpen();
              }}
            />
            {t('experience.newExperience')}</ModalHeader>
          <ModalBody >
            <Box p={3}>
              <NewExperienceInProductForm
                objectiveDefault={objectiveDefault}
                productId={productId}
                groupId={group ? group.id : null}
                hideSave={true}
                onSubmitting={() => {
                  setIsAdding(true);
                }}
                onSubmitted={async () => {
                  setIsAdding(false);
                  await onNew();
                  modalCreateExperience.onClose();
                }}
                onValidityChange={setIsValid}
                ref={ref2}
              />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
              variant='purpleOutline'
              onClick={() => {
                modalCreateExperience.onClose();
                modalAddExperience.onOpen();
              }}
            >{t('common.cancel')}</Button>
            <Button
              variant="purpleFill"
              ml={2}
              isLoading={isAdding}
              isDisabled={!isValid}
              onClick={() => {
                ref2.current.click();
                modalCreateExperience.onClose();
              }}>{t('common.save')}</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={modalAddExperienceGroup.isOpen} onClose={modalAddExperienceGroup.onClose}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>{t('product.newExperienceGroup')}</ModalHeader>
          <ModalBody >
            <Box p={3}>
              <NewExperienceGroupInProductForm
                productId={productId}
                hideSave={true}
                groupId={group ? group.id : null}
                onSubmitting={() => {
                  setIsAdding(true);
                }}
                onSubmitted={async () => {
                  setIsAdding(false);
                  await onNew();
                  modalAddExperienceGroup.onClose();
                }}
                onValidityChange={setIsValid}
                ref={ref3}
              />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
              variant='purpleOutline'
              onClick={modalAddExperienceGroup.onClose}
            >{t('common.cancel')}</Button>
            <Button
              variant="purpleFill"
              ml={2}
              isLoading={isAdding}
              isDisabled={!isValid}
              onClick={() => {
                ref3.current.click();
                modalAddExperienceGroup.onClose();
              }}>{t('common.save')}</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={modalAddSharedExperience.isOpen} onClose={modalAddSharedExperience.onClose}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>{t('product.addSharedExperiences')}</ModalHeader>
          <ModalBody >
            <Box p={3}>
              <AddSharedExperienceToProductModalForm
                productId={productId}
                groupId={group ? group.id : null}
                hideSave={true}
                onSubmitting={() => {
                  setIsAdding(true);
                }}
                onSubmitted={async () => {
                  setIsAdding(false);
                  await onNew();
                  modalAddSharedExperience.onClose();
                }}
                onCreateNew={(name) => {
                  setObjectiveDefault(name);
                  modalAddSharedExperience.onClose();
                  modalCreateSharedExperience.onOpen();
                }}
                ref={ref4}
              />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="purpleOutline"
              onClick={modalAddSharedExperience.onClose}
            >{t('common.cancel')}</Button>
            <Button
              variant="purpleFill"
              ml={2}
              onClick={() => {
                ref4.current.click();
              }}>{t('common.save')}</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={modalCreateSharedExperience.isOpen} onClose={modalCreateSharedExperience.onClose}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>
            <IconButton
              fontSize='24'
              variant="tertiary"
              icon={<MdArrowBack />}
              aria-label='Back'
              mr={2}
              onClick={() => {
                modalCreateSharedExperience.onClose();
                modalAddSharedExperience.onOpen();
              }}
            />
            {t('sharedExperience.newSharedExperience')}</ModalHeader>
          <ModalBody >
            <Box p={3}>
              <SharedExperienceForm
                hideSave={true}
                onSubmitting={() => {
                  setIsAdding(true);
                }}
                onSubmitted={async (newSharedExperience) => {
                  setIsAdding(false);
                  if (newSharedExperience && newSharedExperience.id) {
                    try {
                      await sharedExperiencesApi.linkProductToSharedExperience(newSharedExperience.id, productId);
                      await onNew();
                    } catch (error) {
                      console.error('Error linking new shared experience:', error);
                    }
                    modalCreateSharedExperience.onClose();
                  }
                }}
                onValidityChange={setIsValid}
                ref={ref5}
              />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
              variant='purpleOutline'
              onClick={() => {
                modalCreateSharedExperience.onClose();
                modalAddSharedExperience.onOpen();
              }}
            >{t('common.cancel')}</Button>
            <Button
              variant="purpleFill"
              ml={2}
              isLoading={isAdding}
              isDisabled={!isValid}
              onClick={() => {
                ref5.current.click();
              }}>{t('common.save')}</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}